module.exports = __webpack_public_path__ + "img/3.19aca78a.png";